
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipper/expedited-shipping",
      function () {
        return require("private-next-pages/shipper/expedited-shipping.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipper/expedited-shipping"])
      });
    }
  